var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCFooterInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9H22V14H22.5C23.8807 14 25 12.8807 25 11.5C25 10.1193 23.8807 9 22.5 9Z",
    stroke: "#8292AB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7C18.5 10.3195 18.5 19 18.5 19",
    stroke: "#8292AB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5L7.78798 23.1728C8.08698 24.2887 9.23398 24.9509 10.3499 24.6519V24.6519C11.4657 24.3529 12.128 23.2059 11.829 22.0901L11.2057 19.7639",
    stroke: "#8292AB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.513 17.4152L10.25 16.4336",
    stroke: "#8292AB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.3005V3.69951C22 2.93703 21.1809 2.45506 20.5144 2.82536L13.2265 6.87416C13.078 6.95669 12.9108 7 12.7409 7H5C4.44772 7 4 7.44772 4 8V15C4 15.5523 4.44772 16 5 16H12.7409C12.9108 16 13.078 16.0433 13.2265 16.1258L20.5144 20.1746C21.1809 20.5449 22 20.063 22 19.3005Z",
    stroke: "#8292AB",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCFooterInfo);
export default __webpack_public_path__ + "static/media/icon_c_footer_info.71b0ce0e1ffbcb5161a2a771da76d102.svg";
export { ForwardRef as ReactComponent };